import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Zap, Sprout, Gamepad2, Users, Wallet, MoreHorizontal } from "lucide-react";
import { useAccount } from "wagmi";
import { useConnectWallet } from "@/components/wallet/ConnectWalletButton";
import { MoreSheet } from "./MoreSheet";

const TABS = [
  { to: "/dashboard", label: "Home", icon: Zap, tid: "tab-dashboard" },
  { to: "/farm", label: "Farm", icon: Sprout, tid: "tab-farm" },
  { to: "/arcade", label: "Arcade", icon: Gamepad2, tid: "tab-arcade" },
  { to: "/hubs", label: "Hubs", icon: Users, tid: "tab-hubs" },
];
export const TAB_PATHS = TABS.map((t) => t.to);

const tabCls = (active) => `flex-1 flex flex-col items-center justify-center gap-0.5 py-2 text-[11px] font-semibold transition-colors ${active ? "text-orange-400" : "text-slate-400 active:text-slate-200"}`;

export function MobileTabBar({ moreLinks }) {
  const { pathname } = useLocation();
  const { isConnected } = useAccount();
  const { start, sheet } = useConnectWallet();
  const [moreOpen, setMoreOpen] = useState(false);
  const walletActive = pathname.startsWith("/profile");
  return (
    <>
      <nav className="md:hidden fixed bottom-0 inset-x-0 z-40 bg-[#0F101A]/95 backdrop-blur-xl border-t border-[#2A2E45] pb-[env(safe-area-inset-bottom)]" data-testid="mobile-tab-bar">
        <div className="flex">
          {TABS.map((t) => (
            <Link key={t.to} to={t.to} className={tabCls(pathname.startsWith(t.to))} data-testid={t.tid}>
              <t.icon size={20} /> {t.label}
            </Link>
          ))}
          {isConnected ? (
            <Link to="/profile" className={tabCls(walletActive)} data-testid="tab-wallet"><Wallet size={20} /> Wallet</Link>
          ) : (
            <button onClick={start} className={tabCls(false)} data-testid="tab-wallet-connect"><Wallet size={20} className="text-orange-400" /> Connect</button>
          )}
          <button onClick={() => setMoreOpen(true)} className={tabCls(moreOpen)} data-testid="tab-more"><MoreHorizontal size={20} /> More</button>
        </div>
      </nav>
      {sheet}
      <MoreSheet open={moreOpen} onOpenChange={setMoreOpen} links={moreLinks} />
    </>
  );
}
